import classNames from 'classnames';
import type { CSSProperties } from 'styled-components';
import styled from 'styled-components';

import type { Rarity } from '__generated__/globalTypes';
import crest from 'assets/user/crest.png';
import { Horizontal } from 'atoms/layout/flex';
import { getRarityColor } from 'lib/colors';

import { ResponsiveImg } from '../ResponsiveImg';

const Wrapper = styled.div`
  width: 100%;
  aspect-ratio: 1;
  border: 1px solid var(--border-color, var(--c-black));
  border-radius: 50%;
`;

const Avatar = styled(Horizontal).attrs({ gap: 0, center: true })`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  box-shadow: inset 0px 0px 0px 1px var(--c-black);
  overflow: hidden;
`;

const Img = styled(ResponsiveImg)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
`;

type Props = {
  name?: string;
  avatarUrl?: string | null;
  scarcity?: Rarity;
  className?: string;
};

export const ScarcityAvatar = ({
  avatarUrl,
  name,
  scarcity,
  className,
}: Props) => {
  return (
    <Wrapper
      className={classNames(scarcity, className)}
      style={
        {
          '--border-color': scarcity ? getRarityColor(scarcity) : undefined,
        } as CSSProperties
      }
    >
      <Avatar>
        <Img src={avatarUrl || crest} alt={name || ''} cropWidth={40} />
      </Avatar>
    </Wrapper>
  );
};
